import {NavLink} from 'react-router-dom';
import {Box, Breadcrumbs} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {formatPerson} from '@flexinet/ui-components';
import {User} from '../types';
import config from '../config';

// The last crumb names the person the same way the page heading does.
export const EditPageNavigation = ({component}: { component: User }) => {
    const breadcrumbs = [
        {title: I18n.get('Home'), href: '/'},
        {title: I18n.get(config.titles.plural), href: config.basePath},
        {title: formatPerson(component) ?? component.id},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
